import { capitalize } from 'lodash';

import AvantLogoImg from 'assets/images/ay/ay-technologies-black.svg';
import MapBoxLogoImg from 'assets/images/icons/mapbox-logo.svg';
import { I18N_PLATFORM_COMMON_WORD_PATH } from 'constants/i18n';
import { DOT } from 'constants/placeholders';
import { PropertyCompanyType } from 'constants/propertyCompanyType';
import { IPropertyCompany } from 'interfaces/IPropertyCompany';
import { translateText } from 'utils/i18n';

import { SuggestionIcon } from '../enums';

const isNotMarketOrSubmarket = (propertyCompany: IPropertyCompany) => {
  return (
    propertyCompany.type !== PropertyCompanyType.MARKET &&
    propertyCompany.type !== PropertyCompanyType.SUBMARKET
  );
};

export const getSubmarketDetails = (propertyCompany: IPropertyCompany) => {
  if (isNotMarketOrSubmarket(propertyCompany)) return '';

  return [
    propertyCompany.state,
    propertyCompany.propertyType,
    `${propertyCompany.numberOfBuildings} ${capitalize(
      translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.building`, {
        count: propertyCompany.numberOfBuildings,
      }),
    )}`,
  ]
    .filter(Boolean)
    .join(` ${DOT} `);
};

export const getSourceIcon = (type?: string) => {
  if (type === SuggestionIcon.mapBoxAddress)
    return {
      icon: MapBoxLogoImg,
      alt: `Mapbox ${translateText(`avantProperties.labels.common.address`)}`,
    };
  return { icon: AvantLogoImg, alt: 'Avison Young' };
};

export const getTradeAreaIcon = (type?: string) => {
  if (type === SuggestionIcon.globalBoundary) {
    return {
      icon: 'world',
      alt: `Icon`,
    };
  }
  return {
    icon: 'mapMarker',
    alt: `Icon`,
  };
};
